import { ReactNode } from "react";

export const RelatedMessageContent = ({ children }: { children: ReactNode; }) => (
    <div className={`relative min-w-0 bg-white/50 block rounded-lg text-sm wrap-break-word mb-1 pt-1 pb-2 px-1.5`}>{children}</div>
);
